export const searchBarBorderColor="#CECACA"
export const white="#FFFFFF"
export const seconderyTextColor="#7A869A"
export const primaryBlue="#2A7CED"
export const primaryGray="#707070"